import { Box, Paper, Tab } from "@mui/material";
import { useEffect, useState } from "react";
import Adjustment from "./Adjustment";
import DailyWage from "./DailyWage";
import Base from "../../../Base/views/Base"
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import ManualWageBulkUpload from "../BulkUpload/ManualWageBulkUpload";

const PostAdjustmentLandingPage = () => {
    const [value, setValue] = useState(0);
    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Paper sx={{ borderRadius: "10px", }}>
                        {children}
                    </Paper>
                )}
            </div>
        );
    }

    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Base>
            <Box sx={{ minHeight: "calc(100vh - 65px)",
                        maxHeight: "calc(100vh - 65px)", overflowY: 'auto' }}>
                <Tabs 
                    value={value} 
                    onChange={handleChange} 
                    aria-label="basic tabs example" 
                    sx={{mb: 1}}
                    variant="scrollable"
                    orientation="horizontal"
                    allowScrollButtonsMobile={true}
                    >
                    <Tab label="Adjustments" {...a11yProps(0)} />
                    <Tab label="Work-Based Pay" {...a11yProps(1)} />
                    <Tab label="PayEntry Bulk Upload" {...a11yProps(2)} />
                </Tabs>
                <TabPanel value={value} index={0}>
                    <Adjustment />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <DailyWage />
                </TabPanel>
                <TabPanel value={value} index={2}>
                    <ManualWageBulkUpload />
                </TabPanel>
            </Box>
        </Base>
    )
}
// ManualWageBulkUpload
export default PostAdjustmentLandingPage;
